import { render } from "./StatementDetails.vue?vue&type=template&id=ce2ef15e&scoped=true"
import script from "./StatementDetails.vue?vue&type=script&lang=js"
export * from "./StatementDetails.vue?vue&type=script&lang=js"

import "./StatementDetails.vue?vue&type=style&index=0&id=ce2ef15e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ce2ef15e"

export default script